import { useGlobalShortcutsDataBFF } from '@atlassian/global-shortcuts';
import { useNavBoundaryContext } from '@atlassian/navigation-error-boundary';

import type { ShortcutsConfig } from '../../../common/types';
import { useOptions } from '../../options-provider';

export function useHydratedShortcuts(rawShortcuts: ShortcutsConfig | undefined): any {
	const { cloudId, isShortcutsStatic, app } = useOptions();
	const { handleError } = useNavBoundaryContext({
		location: 'use-hydrated-shortcuts',
		// Log backend errors only to Sentry
		// see: https://hello.atlassian.net/wiki/spaces/navx/pages/6439960649/NavX+-+FE+Observability#%3Acatchemall%3A--Error-handling
		sentryConfig: { product: app },
		disableAnalytics: true,
	});

	return useGlobalShortcutsDataBFF({
		shortcutsConfig: rawShortcuts,
		cloudId,
		isShortcutsStatic,
		onError: handleError,
		product: app,
	});
}
